<template>
  <v-card width="600">
    <v-system-bar
      color="deep-purple darken-4"
      dark
    >
    </v-system-bar>
    <v-toolbar
      color="deep-purple accent-4"
      cards
      dark
      flat
    >
      <v-icon dark>chat</v-icon>
      <v-toolbar-title>News Article</v-toolbar-title>
    </v-toolbar>
    <v-layout
      align-end
      fill-height
      pl-5
      pr-5
      mt-3
      black--text
    >
      <div class="title font-weight-light">
        Fill in the article, then click submit to get the best news photos from the database for the given article.
      </div>
    </v-layout>
    <v-form
      ref="form"
      v-model="form"
      class="pa-3 pt-4"
    >
      <v-text-field
        v-model="title"
        box
        clearable
        color="deep-purple"
        label="Title"
      ></v-text-field>
      <v-textarea
        v-model="lead"
        auto-grow
        box
        clearable
        color="deep-purple"
        label="Lead"
        rows="1"
      >
      </v-textarea>
      <v-textarea
        v-model="caption"
        auto-grow
        box
        clearable
        color="deep-purple"
        label="Image Caption"
        rows="1"
      ></v-textarea>
      <div
        v-show="coloredCaption"
        class="py-2"
        style="border-style: solid; border-width: 1px;"
      >
        <span class="grey--text pa-2">Attention scores</span><br>
        <div
          v-html="captionHTML"
          class="title px-2 "
        >
        </div>
        <v-spacer />
      </div>
      <v-textarea
        v-model="article"
        auto-grow
        box
        clearable
        color="deep-purple"
        label="Article Body"
        rows="5"
        style="max-height: 400px; overflow-y: auto;"
      ></v-textarea>
      <v-layout row>
        <v-flex xs6>
          <v-text-field
            v-model="nimages"
            outline
            color="deep-purple"
            label="Enter number of images to retrieve"
          />
        </v-flex>
        <v-flex xs4>
          <v-select
            :items="lang"
            v-model="selectedLang"
            :rules="[v => !!v || 'Language is required']"
            outline
            label="Select language"
            color="deep-purple"
            chips
            persistent-hint
            required
          ></v-select>
        </v-flex>
        <v-flex xs2>
          <v-tooltip bottom>
            <v-btn
              slot="activator"
              :flat="!show"
              icon
              large
              class="white--text"
              color="deep-purple accent-4"
              @click="show = !show"
            >
              <v-icon :color=" show?'white':'deep-purple accent-4' ">
                filter_list
              </v-icon>
            </v-btn>
            <span>Filter images by named entities.</span>
          </v-tooltip>
        </v-flex>
      </v-layout>

      <v-slide-y-transition>
        <v-card
          v-show="show"
          color="deep-purple lighten-5"
          class="deep-purple--text"
        >
          <v-card-title primary-title>
            <div>
              <div class="headline">Filtering by Named Entities</div>
              <span>Retrieve images containing the listed named entity in the article content.</span>
            </div>
          </v-card-title>
          <v-card-text>
            <v-combobox
              v-model="chips"
              :items="items"
              outline
              chips
              clearable
              multiple
              append-icon
              color="deep-purple accent-4"
              label="Select or enter named entities"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip
                  :selected="data.selected"
                  color="deep-purple accent-4"
                  text-color="white"
                  close
                  @input="remove(data.item)"
                >
                  {{ data.item }}
                </v-chip>
              </template>
            </v-combobox>
            <v-tooltip top>
              <v-radio-group
                v-model="entityQuery"
                slot="activator"
                row
              >
                <v-radio
                  label="OR"
                  value="or"
                  color="deep-purple accent-4"
                ></v-radio>
                <v-radio
                  label="AND"
                  value="and"
                  color="deep-purple accent-4"
                ></v-radio>
              </v-radio-group>
              <span>Display images with all entities (AND) or any of the entities (OR).</span>
            </v-tooltip>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-tooltip left>
              <v-btn
                slot="activator"
                flat
                class="white--text"
                color="deep-purple accent-4"
                @click="getEntities()"
                :disabled="isEmpty"
              >
                Extract Named Entities
              </v-btn>
              <span>Automatically extract named entities from the article content.</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-slide-y-transition>
    </v-form>
    <v-divider></v-divider>
    <v-card-actions>
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          flat
          @click="clear(); removeImages();"
        >
          Clear
        </v-btn>
        <span>Clear news article content.</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          flat
          class="white--text"
          color="deep-purple accent-4"
          @click="getRandomArticle()"
        >
          Random
        </v-btn>
        <span>Fetch a random article from the database.</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          :loading="isLoading"
          class="white--text"
          color="deep-purple accent-4"
          @click="getImages()"
          depressed
          :disabled="isEmpty"
        >
          Submit
        </v-btn>
        <span>Retrieve the best illustration images for that article.</span>
      </v-tooltip>
    </v-card-actions>
    <v-snackbar
      v-model="entitySnackbar"
      :timeout="timeout"
      bottom
      multi-line
    >
      Named entities extracted.<br>
      Please select entities from the list.
      <v-btn
        color="deep-purple accent-1"
        flat
        @click="entitySnackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>

    <v-snackbar
      v-model="noResultSnackbar"
      :timeout="timeout"
      bottom
    >
      No image found with those named entities.
      <v-btn
        color="deep-purple accent-1"
        flat
        @click="noResultSnackbar = false"
        top
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'

export default {
  data: () => ({
    article: '',
    lead: '',
    caption: '',
    title: '',
    nimages: 30,
    isLoading: false,
    form: false,
    images: [],
    items: [],
    chips: [],
    entityQuery: 'or',
    lang: ['de', 'fr'],
    selectedLang: 'de',
    show: false,
    entitySnackbar: false,
    timeout: 6000,
  }),
  computed: {
    captionHTML() {
      return this.attn.join(' ');
    },
    isEmpty() {
      if (this.article === '' & this.lead === '' & this.caption === '' & this.title === '') {
        return true;
      } else {
        return false;
      }
    },
    noResultSnackbar: {
      get() {
        return this.noResult;
      },
      set(value) {
        this.setNoResult(value)
      }
    },
    ...mapGetters(['models', 'attn', 'coloredCaption', 'noResult'])
  },
  methods: {
    ...mapActions(['fetchImages', 'removeImages', 'setNoResult']),
    getImages() {
      if (this.$refs.form.validate()) {
        this.removeImages();
        this.fetchImages({
          'headline': this.title || '',
          'lead': this.lead || '',
          'caption': this.caption || '',
          'body': this.article || '',
          'entities': this.chips,
          'operator': this.entityQuery,
          'lang': this.selectedLang,
          'k': this.nimages
        });
      }
    },
    getRandomArticle() {
      axios.get('/random/' + this.selectedLang).then(response => {
        // eslint-disable-next-line
        console.log(response)
        this.article = response.data['body']
        this.lead = response.data['lead']
        this.caption = response.data['caption']
        this.title = response.data['headline']
        this.removeImages();
        this.items = [];
        this.chips = [];
      })
    },
    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1)
      this.chips = [...this.chips]
    },
    async getEntities() {
      this.items = [];
      let { data } = await axios.post('/entities/' + this.selectedLang, {
        body: this.article || '',
        lead: this.lead || '',
        caption: this.caption || '',
        headline: this.title || ''
      });
      // eslint-disable-next-line
      console.log(data);
      data.forEach(element => {
        if (!this.items.includes(element.text))
          this.items.push(element.text);
      });
      this.entitySnackbar = true;
    },
    clear() {
      this.article = '';
      this.lead = '';
      this.caption = '';
      this.title = '';
    }
  }
}
</script>
